export type EntityAction = {
	name: string;
	subChips?: string[];
	filters?: { name: string; values?: string[]; filterValue?: string }[];
	actionNames: { name: string; value: string }[];
};

export const entityNames: Record<string, EntityAction> = {
	ACCOUNTINGRULE: {
		name: 'Accountingrule',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	ACCOUNTNUMBERFORMAT: {
		name: 'Accountnumberformat',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	ACCOUNTTRANSFER: {
		name: 'Accounttransfer',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Refundbytransfer',
				value: 'REFUNDBYTRANSFER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ADDRESS: {
		name: 'Address',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	ADHOC: {
		name: 'Adhoc',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	AUDIT: {
		name: 'Audit',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active App User': {
		name: 'Active App User',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Clients - Email': {
		name: 'Active Clients - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Group Leaders - Email': {
		name: 'Active Group Leaders - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loan Clients - Email': {
		name: 'Active Loan Clients - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loan Summary per Branch': {
		name: 'Active Loan Summary Per Branch',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans - Details': {
		name: 'Active Loans - Details',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans - Summary': {
		name: 'Active Loans - Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans - Summary(Pentaho)': {
		name: 'Active Loans - Summary(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans Passed Final Maturity': {
		name: 'Active Loans Passed Final Maturity',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans Passed Final Maturity Summary': {
		name: 'Active Loans Passed Final Maturity Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans Passed Final Maturity Summary(Pentaho)': {
		name: 'Active Loans Passed Final Maturity Summary(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans Passed Final Maturity(Pentaho)': {
		name: 'Active Loans Passed Final Maturity(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans by Disbursal Period': {
		name: 'Active Loans By Disbursal Period',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans by Disbursal Period(Pentaho)': {
		name: 'Active Loans By Disbursal Period(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans in last installment': {
		name: 'Active Loans In Last Installment',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans in last installment Summary': {
		name: 'Active Loans In Last Installment Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans in last installment Summary(Pentaho)': {
		name: 'Active Loans In Last Installment Summary(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Active Loans in last installment(Pentaho)': {
		name: 'Active Loans In Last Installment(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Aging Detail': {
		name: 'Aging Detail',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Aging Detail(Pentaho)': {
		name: 'Aging Detail(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Aging Summary (Arrears in Months)': {
		name: 'Aging Summary (Arrears In Months)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Aging Summary (Arrears in Months)(Pentaho)': {
		name: 'Aging Summary (Arrears In Months)(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Aging Summary (Arrears in Weeks)': {
		name: 'Aging Summary (Arrears In Weeks)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Aging Summary (Arrears in Weeks)(Pentaho)': {
		name: 'Aging Summary (Arrears In Weeks)(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	BATCH_BUSINESS_STEP: {
		name: 'Batch Business Step',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	BIVIEW: {
		name: 'Biview',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	BUSINESS_DATE: {
		name: 'Business Date',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	'Balance Outstanding': {
		name: 'Balance Outstanding',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Balance Sheet': {
		name: 'Balance Sheet',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Branch Expected Cash Flow': {
		name: 'Branch Expected Cash Flow',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	BranchManagerStats: {
		name: 'Branchmanagerstats',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	CACHE: {
		name: 'Cache',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	CALENDAR: {
		name: 'Calendar',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
		],
	},
	CENTER: {
		name: 'Center',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Associategroups Checker',
				value: 'ASSOCIATEGROUPS_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Disassociategroups Checker',
				value: 'DISASSOCIATEGROUPS_CHECKER',
			},
			{
				name: 'Savecollectionsheet',
				value: 'SAVECOLLECTIONSHEET',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Associategroups',
				value: 'ASSOCIATEGROUPS',
			},
			{
				name: 'Disassociategroups',
				value: 'DISASSOCIATEGROUPS',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	CHARGE: {
		name: 'Charge',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	CHARTSLAB: {
		name: 'Chartslab',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	CLIENT: {
		name: 'Client',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATESAVINGSACCOUNT', 'UPDATE', 'UPDATE_CHECKER'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Reject Checker',
				value: 'REJECT_CHECKER',
			},
			{
				name: 'Withdraw',
				value: 'WITHDRAW',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Proposeandaccepttransfer Checker',
				value: 'PROPOSEANDACCEPTTRANSFER_CHECKER',
			},
			{
				name: 'Proposetransfer',
				value: 'PROPOSETRANSFER',
			},
			{
				name: 'Rejecttransfer',
				value: 'REJECTTRANSFER',
			},
			{
				name: 'Accepttransfer Checker',
				value: 'ACCEPTTRANSFER_CHECKER',
			},
			{
				name: 'Assignstaff',
				value: 'ASSIGNSTAFF',
			},
			{
				name: 'Proposeandaccepttransfer',
				value: 'PROPOSEANDACCEPTTRANSFER',
			},
			{
				name: 'Reactivate',
				value: 'REACTIVATE',
			},
			{
				name: 'Rejecttransfer Checker',
				value: 'REJECTTRANSFER_CHECKER',
			},
			{
				name: 'Undoreject',
				value: 'UNDOREJECT',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Withdrawtransfer',
				value: 'WITHDRAWTRANSFER',
			},
			{
				name: 'Proposetransfer Checker',
				value: 'PROPOSETRANSFER_CHECKER',
			},
			{
				name: 'Accepttransfer',
				value: 'ACCEPTTRANSFER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Withdrawtransfer Checker',
				value: 'WITHDRAWTRANSFER_CHECKER',
			},
			{
				name: 'Undotransaction',
				value: 'UNDOTRANSACTION',
			},
			{
				name: 'Undotransaction Checker',
				value: 'UNDOTRANSACTION_CHECKER',
			},
			{
				name: 'Undowithdrawal',
				value: 'UNDOWITHDRAWAL',
			},
			{
				name: 'Undowithdrawal Checker',
				value: 'UNDOWITHDRAWAL_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Reactivate Checker',
				value: 'REACTIVATE_CHECKER',
			},
			{
				name: 'Undoreject Checker',
				value: 'UNDOREJECT_CHECKER',
			},
			{
				name: 'Readtransaction',
				value: 'READTRANSACTION',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Updatesavingsaccount',
				value: 'UPDATESAVINGSACCOUNT',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Unassignstaff',
				value: 'UNASSIGNSTAFF',
			},
			{
				name: 'Withdraw Checker',
				value: 'WITHDRAW_CHECKER',
			},
		],
	},
	CLIENTCHARGE: {
		name: 'Clientcharge',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Inactivate Checker',
				value: 'INACTIVATE_CHECKER',
			},
			{
				name: 'Pay',
				value: 'PAY',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Waive Checker',
				value: 'WAIVE_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Inactivate',
				value: 'INACTIVATE',
			},
			{
				name: 'Pay Checker',
				value: 'PAY_CHECKER',
			},
			{
				name: 'Waive',
				value: 'WAIVE',
			},
		],
	},
	CLIENTIDENTIFIER: {
		name: 'Clientidentifier',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	CLIENTIMAGE: {
		name: 'Clientimage',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	CLIENTNOTE: {
		name: 'Clientnote',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	CLIENT_COLLATERAL_PRODUCT: {
		name: 'Client Collateral Product',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	CODE: {
		name: 'Code',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	CODEVALUE: {
		name: 'Codevalue',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	COLLATERAL: {
		name: 'Collateral',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	COLLATERAL_PRODUCT: {
		name: 'Collateral Product',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	COLLECTIONSHEET: {
		name: 'Collectionsheet',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Save',
				value: 'SAVE',
			},
		],
	},
	CONFIGURATION: {
		name: 'Configuration',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	CREDITBUREAU_CONFIGURATION: {
		name: 'Creditbureau Configuration',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	CREDITBUREAU_LOANPRODUCT_MAPPING: {
		name: 'Creditbureau Loanproduct Mapping',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	CREDITREPORT: {
		name: 'Creditreport',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE'],
			},
		],
		actionNames: [
			{
				name: 'Get',
				value: 'GET',
			},
			{
				name: 'Save',
				value: 'SAVE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	CURRENCY: {
		name: 'Currency',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	ChildrenStaffList: {
		name: 'Childrenstafflist',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Credit Info': {
		name: 'Client Credit Info',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Listing': {
		name: 'Client Listing',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Listing Kakuma': {
		name: 'Client Listing Kakuma',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Listing(Pentaho)': {
		name: 'Client Listing(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Loan Account Schedule': {
		name: 'Client Loan Account Schedule',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Loans Listing': {
		name: 'Client Loans Listing',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Loans Listing(Pentaho)': {
		name: 'Client Loans Listing(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Saving Transactions': {
		name: 'Client Saving Transactions',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Client Savings Summary': {
		name: 'Client Savings Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'ClientSummary ': {
		name: 'Clientsummary ',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ClientTrendsByDay: {
		name: 'Clienttrendsbyday',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ClientTrendsByMonth: {
		name: 'Clienttrendsbymonth',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ClientTrendsByWeek: {
		name: 'Clienttrendsbyweek',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Collection Report': {
		name: 'Collection Report',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	CoordinatorStats: {
		name: 'Coordinatorstats',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	DATATABLE: {
		name: 'Datatable',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Register Checker',
				value: 'REGISTER_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Deregister',
				value: 'DEREGISTER',
			},
			{
				name: 'Deregister Checker',
				value: 'DEREGISTER_CHECKER',
			},
			{
				name: 'Register',
				value: 'REGISTER',
			},
		],
	},
	DELINQUENCY_ACTION: {
		name: 'Delinquency Action',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	DELINQUENCY_BUCKET: {
		name: 'Delinquency Bucket',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	DELINQUENCY_RANGE: {
		name: 'Delinquency Range',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	DELINQUENCY_TAGS: {
		name: 'Delinquency Tags',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	DISBURSEMENTDETAIL: {
		name: 'Disbursementdetail',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	DOCUMENT: {
		name: 'Document',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
		],
	},
	Demand_Vs_Collection: {
		name: 'Demand Vs Collection',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Disbursal Report': {
		name: 'Disbursal Report',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	Disbursal_Vs_Awaitingdisbursal: {
		name: 'Disbursal Vs Awaitingdisbursal',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Dormant Prospects - Email': {
		name: 'Dormant Prospects - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	EMAIL: {
		name: 'Email',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	EMAIL_CAMPAIGN: {
		name: 'Email Campaign',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Reactivate',
				value: 'REACTIVATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	EMAIL_CONFIGURATION: {
		name: 'Email Configuration',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	ENTITYMAPPING: {
		name: 'Entitymapping',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	ENTITY_DATATABLE_CHECK: {
		name: 'Entity Datatable Check',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	EXTERNALSERVICES: {
		name: 'Externalservices',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	EXTERNAL_ASSET_OWNER_LOAN_PRODUCT_ATTRIBUTE: {
		name: 'External Asset Owner Loan Product Attribute',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	EXTERNAL_EVENT_CONFIGURATION: {
		name: 'External Event Configuration',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	'Expected Payments By Date - Basic': {
		name: 'Expected Payments By Date - Basic',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Expected Payments By Date - Basic(Pentaho)': {
		name: 'Expected Payments By Date - Basic(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Expected Payments By Date - Formatted': {
		name: 'Expected Payments By Date - Formatted',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	FAMILYMEMBERS: {
		name: 'Familymembers',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	FINANCIALACTIVITYACCOUNT: {
		name: 'Financialactivityaccount',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	FIXEDDEPOSITACCOUNT: {
		name: 'Fixeddepositaccount',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
			{
				name: 'Approve',
				values: ['APPROVE', 'APPROVE_CHECKER'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Withdrawal',
				value: 'WITHDRAWAL',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Approve Checker',
				value: 'APPROVE_CHECKER',
			},
			{
				name: 'Withdraw',
				value: 'WITHDRAW',
			},
			{
				name: 'Withdraw Checker',
				value: 'WITHDRAW_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Postinterest',
				value: 'POSTINTEREST',
			},
			{
				name: 'Adjusttransaction',
				value: 'ADJUSTTRANSACTION',
			},
			{
				name: 'Deposit Checker',
				value: 'DEPOSIT_CHECKER',
			},
			{
				name: 'Postinterest Checker',
				value: 'POSTINTEREST_CHECKER',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Approvalundo Checker',
				value: 'APPROVALUNDO_CHECKER',
			},
			{
				name: 'Close Checker',
				value: 'CLOSE_CHECKER',
			},
			{
				name: 'Deposit',
				value: 'DEPOSIT',
			},
			{
				name: 'Prematureclose',
				value: 'PREMATURECLOSE',
			},
			{
				name: 'Approvalundo',
				value: 'APPROVALUNDO',
			},
			{
				name: 'Prematureclose Checker',
				value: 'PREMATURECLOSE_CHECKER',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Withdrawal Checker',
				value: 'WITHDRAWAL_CHECKER',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Calculateinterest',
				value: 'CALCULATEINTEREST',
			},
			{
				name: 'Calculateinterest Checker',
				value: 'CALCULATEINTEREST_CHECKER',
			},
			{
				name: 'Reject Checker',
				value: 'REJECT_CHECKER',
			},
			{
				name: 'Undotransaction',
				value: 'UNDOTRANSACTION',
			},
			{
				name: 'Undotransaction Checker',
				value: 'UNDOTRANSACTION_CHECKER',
			},
		],
	},
	FIXEDDEPOSITPRODUCT: {
		name: 'Fixeddepositproduct',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	FLOATINGRATE: {
		name: 'Floatingrate',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	FUND: {
		name: 'Fund',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	FieldAgentPrograms: {
		name: 'Fieldagentprograms',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	FieldAgentStats: {
		name: 'Fieldagentstats',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Funds Disbursed Between Dates Summary': {
		name: 'Funds Disbursed Between Dates Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Funds Disbursed Between Dates Summary by Office': {
		name: 'Funds Disbursed Between Dates Summary By Office',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Funds Disbursed Between Dates Summary by Office(Pentaho)': {
		name: 'Funds Disbursed Between Dates Summary By Office(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Funds Disbursed Between Dates Summary(Pentaho)': {
		name: 'Funds Disbursed Between Dates Summary(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	GLACCOUNT: {
		name: 'Glaccount',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	GLCLOSURE: {
		name: 'Glclosure',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	GLIMLOAN: {
		name: 'Glimloan',
		filters: [
			{
				name: 'Approve',
				values: ['APPROVE'],
			},
			{
				name: 'Disburse',
				values: ['DISBURSE'],
			},
		],
		actionNames: [
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Disburse',
				value: 'DISBURSE',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Repayment',
				value: 'REPAYMENT',
			},
			{
				name: 'Undoapproval',
				value: 'UNDOAPPROVAL',
			},
			{
				name: 'Undodisbursal',
				value: 'UNDODISBURSAL',
			},
		],
	},
	GROUP: {
		name: 'Group',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATEROLE', 'UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Transferclients',
				value: 'TRANSFERCLIENTS',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Savecollectionsheet',
				value: 'SAVECOLLECTIONSHEET',
			},
			{
				name: 'Transferclients Checker',
				value: 'TRANSFERCLIENTS_CHECKER',
			},
			{
				name: 'Updaterole',
				value: 'UPDATEROLE',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Associateclients',
				value: 'ASSOCIATECLIENTS',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Disassociateclients',
				value: 'DISASSOCIATECLIENTS',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Unassignstaff Checker',
				value: 'UNASSIGNSTAFF_CHECKER',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Assignrole',
				value: 'ASSIGNROLE',
			},
			{
				name: 'Assignstaff',
				value: 'ASSIGNSTAFF',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Unassignrole',
				value: 'UNASSIGNROLE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Unassignstaff',
				value: 'UNASSIGNSTAFF',
			},
		],
	},
	GROUPNOTE: {
		name: 'Groupnote',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
		],
	},
	GSIMACCOUNT: {
		name: 'Gsimaccount',
		filters: [
			{
				name: 'Approve',
				values: ['APPROVE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Deposit',
				value: 'DEPOSIT',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Approvalundo',
				value: 'APPROVALUNDO',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	GUARANTOR: {
		name: 'Guarantor',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	'General Ledger Entries ': {
		name: 'General Ledger Entries ',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'General Ledger Report': {
		name: 'General Ledger Report',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	GroupNamesByStaff: {
		name: 'Groupnamesbystaff',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	GroupSavingSummary: {
		name: 'Groupsavingsummary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	GroupSummaryAmounts: {
		name: 'Groupsummaryamounts',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	GroupSummaryCounts: {
		name: 'Groupsummarycounts',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	HOLIDAY: {
		name: 'Holiday',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	HOOK: {
		name: 'Hook',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	'Happy Birthday - Email': {
		name: 'Happy Birthday - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	IMPORT: {
		name: 'Import',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	INLINE_JOB: {
		name: 'Inline Job',
		actionNames: [
			{
				name: 'Execute',
				value: 'EXECUTE',
			},
		],
	},
	INTERESTRATECHART: {
		name: 'Interestratechart',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	INTERID: {
		name: 'Interid',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	INTERQUOTE: {
		name: 'Interquote',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	INTERREQUEST: {
		name: 'Interrequest',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	INTERTRANSFER: {
		name: 'Intertransfer',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Release',
				value: 'RELEASE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Prepare',
				value: 'PREPARE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Income Statement': {
		name: 'Income Statement',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	JOURNALENTRY: {
		name: 'Journalentry',
		filters: [
			{
				name: 'Reverse',
				values: ['REVERSE'],
			},
			{
				name: 'Update',
				values: ['UPDATERUNNINGBALANCE'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Updaterunningbalance',
				value: 'UPDATERUNNINGBALANCE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Defineopeningbalance',
				value: 'DEFINEOPENINGBALANCE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Reverse',
				value: 'REVERSE',
			},
		],
	},
	'Kakuma Loan Analysis': {
		name: 'Kakuma Loan Analysis',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Kakuma Loan Analysis New': {
		name: 'Kakuma Loan Analysis New',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Kakuma Loan Transactions': {
		name: 'Kakuma Loan Transactions',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Kakuma Loans Report': {
		name: 'Kakuma Loans Report',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Kakuma Member Savings And Loans': {
		name: 'Kakuma Member Savings And Loans',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Kakuma Savings Balance': {
		name: 'Kakuma Savings Balance',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Kakuma Savings Transactions': {
		name: 'Kakuma Savings Transactions',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	LOAN: {
		name: 'Loan',
		filters: [
			{
				name: 'Approve',
				values: ['APPROVE', 'APPROVE_CHECKER'],
			},
			{
				name: 'Disburse',
				values: [
					'DISBURSETOSAVINGS',
					'DISBURSEWITHOUTAUTODOWNPAYMENT',
					'DISBURSE',
					'DISBURSE_CHECKER',
				],
			},
			{
				name: 'Update',
				values: [
					'UPDATEDELINQUENCY',
					'UPDATE',
					'UPDATE_CHECKER',
					'UPDATELOANOFFICER',
					'UPDATELOANOFFICER_CHECKER',
				],
			},
			{
				name: 'Create',
				values: [
					'CREATESCHEDULEEXCEPTIONS',
					'CREATESCHEDULEEXCEPTIONS_CHECKER',
					'CREATE',
					'CREATE_CHECKER',
				],
			},
			{
				name: 'Delete',
				values: [
					'DELETESCHEDULEEXCEPTIONS',
					'DELETESCHEDULEEXCEPTIONS_CHECKER',
					'DELETE',
					'DELETE_CHECKER',
				],
			},
		],
		actionNames: [
			{
				name: 'Chargerefund',
				value: 'CHARGEREFUND',
			},
			{
				name: 'Closeasrescheduled Checker',
				value: 'CLOSEASRESCHEDULED_CHECKER',
			},
			{
				name: 'Disbursalundo Checker',
				value: 'DISBURSALUNDO_CHECKER',
			},
			{
				name: 'Disburse Checker',
				value: 'DISBURSE_CHECKER',
			},
			{
				name: 'Repayment',
				value: 'REPAYMENT',
			},
			{
				name: 'Undochargeoff',
				value: 'UNDOCHARGEOFF',
			},
			{
				name: 'Undowriteoff',
				value: 'UNDOWRITEOFF',
			},
			{
				name: 'Writeoff Checker',
				value: 'WRITEOFF_CHECKER',
			},
			{
				name: 'Foreclosure',
				value: 'FORECLOSURE',
			},
			{
				name: 'Creditbalancerefund',
				value: 'CREDITBALANCEREFUND',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Adjust',
				value: 'ADJUST',
			},
			{
				name: 'Recoverypayment',
				value: 'RECOVERYPAYMENT',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Bulkreassign Checker',
				value: 'BULKREASSIGN_CHECKER',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Disbursetosavings',
				value: 'DISBURSETOSAVINGS',
			},
			{
				name: 'Disburse',
				value: 'DISBURSE',
			},
			{
				name: 'Waiveinterestportion Checker',
				value: 'WAIVEINTERESTPORTION_CHECKER',
			},
			{
				name: 'Chargeback',
				value: 'CHARGEBACK',
			},
			{
				name: 'Merchantissuedrefund',
				value: 'MERCHANTISSUEDREFUND',
			},
			{
				name: 'Refundbycash',
				value: 'REFUNDBYCASH',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Reject Checker',
				value: 'REJECT_CHECKER',
			},
			{
				name: 'Removeloanofficer Checker',
				value: 'REMOVELOANOFFICER_CHECKER',
			},
			{
				name: 'Approve Checker',
				value: 'APPROVE_CHECKER',
			},
			{
				name: 'Removeloanofficer',
				value: 'REMOVELOANOFFICER',
			},
			{
				name: 'Sale',
				value: 'SALE',
			},
			{
				name: 'Waiveinterestportion',
				value: 'WAIVEINTERESTPORTION',
			},
			{
				name: 'Withdraw Checker',
				value: 'WITHDRAW_CHECKER',
			},
			{
				name: 'Repayment Checker',
				value: 'REPAYMENT_CHECKER',
			},
			{
				name: 'Updatedelinquency',
				value: 'UPDATEDELINQUENCY',
			},
			{
				name: 'Approvalundo',
				value: 'APPROVALUNDO',
			},
			{
				name: 'Updateloanofficer Checker',
				value: 'UPDATELOANOFFICER_CHECKER',
			},
			{
				name: 'Disbursallastundo',
				value: 'DISBURSALLASTUNDO',
			},
			{
				name: 'Disbursallastundo Checker',
				value: 'DISBURSALLASTUNDO_CHECKER',
			},
			{
				name: 'Withdraw',
				value: 'WITHDRAW',
			},
			{
				name: 'Writeoff',
				value: 'WRITEOFF',
			},
			{
				name: 'Createscheduleexceptions Checker',
				value: 'CREATESCHEDULEEXCEPTIONS_CHECKER',
			},
			{
				name: 'Approvalundo Checker',
				value: 'APPROVALUNDO_CHECKER',
			},
			{
				name: 'Downpayment',
				value: 'DOWNPAYMENT',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Bulkreassign',
				value: 'BULKREASSIGN',
			},
			{
				name: 'Close Checker',
				value: 'CLOSE_CHECKER',
			},
			{
				name: 'Interestpaymentwaiver',
				value: 'INTERESTPAYMENTWAIVER',
			},
			{
				name: 'Recoverguarantees',
				value: 'RECOVERGUARANTEES',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Goodwillcredit',
				value: 'GOODWILLCREDIT',
			},
			{
				name: 'Updateloanofficer',
				value: 'UPDATELOANOFFICER',
			},
			{
				name: 'Setfraud',
				value: 'SETFRAUD',
			},
			{
				name: 'Disbursewithoutautodownpayment',
				value: 'DISBURSEWITHOUTAUTODOWNPAYMENT',
			},
			{
				name: 'Recoverguarantees Checker',
				value: 'RECOVERGUARANTEES_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Deletescheduleexceptions Checker',
				value: 'DELETESCHEDULEEXCEPTIONS_CHECKER',
			},
			{
				name: 'Chargeoff',
				value: 'CHARGEOFF',
			},
			{
				name: 'Disbursalundo',
				value: 'DISBURSALUNDO',
			},
			{
				name: 'Closeasrescheduled',
				value: 'CLOSEASRESCHEDULED',
			},
			{
				name: 'Payoutrefund',
				value: 'PAYOUTREFUND',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Foreclosure Checker',
				value: 'FORECLOSURE_CHECKER',
			},
			{
				name: 'Createscheduleexceptions',
				value: 'CREATESCHEDULEEXCEPTIONS',
			},
			{
				name: 'Deletescheduleexceptions',
				value: 'DELETESCHEDULEEXCEPTIONS',
			},
			{
				name: 'Adjust Checker',
				value: 'ADJUST_CHECKER',
			},
			{
				name: 'Buyback',
				value: 'BUYBACK',
			},
			{
				name: 'Bypass',
				value: 'BYPASS',
			},
		],
	},
	LOANCHARGE: {
		name: 'Loancharge',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Waive',
				value: 'WAIVE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Waive Checker',
				value: 'WAIVE_CHECKER',
			},
			{
				name: 'Adjustment',
				value: 'ADJUSTMENT',
			},
			{
				name: 'Pay',
				value: 'PAY',
			},
		],
	},
	LOANNOTE: {
		name: 'Loannote',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	LOANPRODUCT: {
		name: 'Loanproduct',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	LOANTRANSACTIONNOTE: {
		name: 'Loantransactionnote',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	LOAN_COLLATERAL_PRODUCT: {
		name: 'Loan Collateral Product',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	'Loan Account Schedule': {
		name: 'Loan Account Schedule',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Approved - Email': {
		name: 'Loan Approved - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Fully Repaid - Email': {
		name: 'Loan Fully Repaid - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Payments Due (Overdue Loans) - Email': {
		name: 'Loan Payments Due (Overdue Loans) - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Payments Received (Active Loans) - Email': {
		name: 'Loan Payments Received (Active Loans) - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Payments Received (Overdue Loans)  - Email': {
		name: 'Loan Payments Received (Overdue Loans)  - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Rejected - Email': {
		name: 'Loan Rejected - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Repayment - Email': {
		name: 'Loan Repayment - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan Transactions Report': {
		name: 'Loan Transactions Report',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loan payments due - Email': {
		name: 'Loan Payments Due - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	LoanCyclePerProduct: {
		name: 'Loancycleperproduct',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	LoanTrendsByDay: {
		name: 'Loantrendsbyday',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	LoanTrendsByMonth: {
		name: 'Loantrendsbymonth',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	LoanTrendsByWeek: {
		name: 'Loantrendsbyweek',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Awaiting Disbursal': {
		name: 'Loans Awaiting Disbursal',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Awaiting Disbursal Summary': {
		name: 'Loans Awaiting Disbursal Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Awaiting Disbursal Summary by Month': {
		name: 'Loans Awaiting Disbursal Summary By Month',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Awaiting Disbursal Summary by Month(Pentaho)': {
		name: 'Loans Awaiting Disbursal Summary By Month(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Awaiting Disbursal Summary(Pentaho)': {
		name: 'Loans Awaiting Disbursal Summary(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Awaiting Disbursal(Pentaho)': {
		name: 'Loans Awaiting Disbursal(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Outstanding after final instalment date - Email': {
		name: 'Loans Outstanding After Final Instalment Date - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Pending Approval': {
		name: 'Loans Pending Approval',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans Pending Approval(Pentaho)': {
		name: 'Loans Pending Approval(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans disbursed to clients - Email': {
		name: 'Loans Disbursed To Clients - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Loans in arrears - Email': {
		name: 'Loans In Arrears - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	MEETING: {
		name: 'Meeting',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['SAVEORUPDATEATTENDANCE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Saveorupdateattendance',
				value: 'SAVEORUPDATEATTENDANCE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	OFFICE: {
		name: 'Office',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	OFFICETRANSACTION: {
		name: 'Officetransaction',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	ORGANISATIONCREDITBUREAU: {
		name: 'Organisationcreditbureau',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	'Obligation Met Loans Details': {
		name: 'Obligation Met Loans Details',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Obligation Met Loans Details(Pentaho)': {
		name: 'Obligation Met Loans Details(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Obligation Met Loans Summary': {
		name: 'Obligation Met Loans Summary',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Obligation Met Loans Summary(Pentaho)': {
		name: 'Obligation Met Loans Summary(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	PASSWORD_PREFERENCES: {
		name: 'Password Preferences',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	PAYMENTTYPE: {
		name: 'Paymenttype',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	PERIODICACCRUALACCOUNTING: {
		name: 'Periodicaccrualaccounting',
		actionNames: [
			{
				name: 'Execute',
				value: 'EXECUTE',
			},
		],
	},
	PERMISSION: {
		name: 'Permission',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	POCKET: {
		name: 'Pocket',
		actionNames: [
			{
				name: 'Delink Account From',
				value: 'DELINK_ACCOUNT_FROM',
			},
			{
				name: 'Link Account To',
				value: 'LINK_ACCOUNT_TO',
			},
		],
	},
	PRODUCTMIX: {
		name: 'Productmix',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	PROVISIONCATEGORY: {
		name: 'Provisioncategory',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	PROVISIONINGCRITERIA: {
		name: 'Provisioningcriteria',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	PROVISIONINGENTRIES: {
		name: 'Provisioningentries',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE', 'RECREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Recreate',
				value: 'RECREATE',
			},
		],
	},
	'Portfolio at Risk': {
		name: 'Portfolio At Risk',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Portfolio at Risk by Branch': {
		name: 'Portfolio At Risk By Branch',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Portfolio at Risk by Branch(Pentaho)': {
		name: 'Portfolio At Risk By Branch(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Portfolio at Risk(Pentaho)': {
		name: 'Portfolio At Risk(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ProgramDetails: {
		name: 'Programdetails',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ProgramDirectorStats: {
		name: 'Programdirectorstats',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	ProgramStats: {
		name: 'Programstats',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Prospective Clients - Email': {
		name: 'Prospective Clients - Email',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	RATE: {
		name: 'Rate',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	RECURRINGDEPOSITACCOUNT: {
		name: 'Recurringdepositaccount',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER', 'UPDATEDEPOSITAMOUNT', 'UPDATEDEPOSITAMOUNT'],
			},
			{
				name: 'Approve',
				values: ['APPROVE', 'APPROVE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Approve Checker',
				value: 'APPROVE_CHECKER',
			},
			{
				name: 'Postinterest',
				value: 'POSTINTEREST',
			},
			{
				name: 'Postinterest Checker',
				value: 'POSTINTEREST_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Deposit',
				value: 'DEPOSIT',
			},
			{
				name: 'Withdrawal Checker',
				value: 'WITHDRAWAL_CHECKER',
			},
			{
				name: 'Adjusttransaction',
				value: 'ADJUSTTRANSACTION',
			},
			{
				name: 'Calculateinterest',
				value: 'CALCULATEINTEREST',
			},
			{
				name: 'Deposit Checker',
				value: 'DEPOSIT_CHECKER',
			},
			{
				name: 'Prematureclose',
				value: 'PREMATURECLOSE',
			},
			{
				name: 'Withdraw',
				value: 'WITHDRAW',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Close Checker',
				value: 'CLOSE_CHECKER',
			},
			{
				name: 'Reject Checker',
				value: 'REJECT_CHECKER',
			},
			{
				name: 'Undotransaction Checker',
				value: 'UNDOTRANSACTION_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Approvalundo',
				value: 'APPROVALUNDO',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Withdrawal',
				value: 'WITHDRAWAL',
			},
			{
				name: 'Withdraw Checker',
				value: 'WITHDRAW_CHECKER',
			},
			{
				name: 'Approvalundo Checker',
				value: 'APPROVALUNDO_CHECKER',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Prematureclose Checker',
				value: 'PREMATURECLOSE_CHECKER',
			},
			{
				name: 'Updatedepositamount',
				value: 'UPDATEDEPOSITAMOUNT',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Calculateinterest Checker',
				value: 'CALCULATEINTEREST_CHECKER',
			},
			{
				name: 'Undotransaction',
				value: 'UNDOTRANSACTION',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	RECURRINGDEPOSITPRODUCT: {
		name: 'Recurringdepositproduct',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	REPAYMENT_WITH_POSTDATEDCHECKS: {
		name: 'Repayment With Postdatedchecks',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Bounce',
				value: 'BOUNCE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	REPORT: {
		name: 'Report',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	REPORTMAILINGJOB: {
		name: 'Reportmailingjob',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	RESCHEDULELOAN: {
		name: 'Rescheduleloan',
		filters: [
			{
				name: 'Approve',
				values: ['APPROVE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	ROLE: {
		name: 'Role',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Disable',
				value: 'DISABLE',
			},
			{
				name: 'Disable Checker',
				value: 'DISABLE_CHECKER',
			},
			{
				name: 'Permissions',
				value: 'PERMISSIONS',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Enable',
				value: 'ENABLE',
			},
			{
				name: 'Enable Checker',
				value: 'ENABLE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	'Rescheduled Loans': {
		name: 'Rescheduled Loans',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Rescheduled Loans(Pentaho)': {
		name: 'Rescheduled Loans(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	SAVINGNOTE: {
		name: 'Savingnote',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	SAVINGSACCOUNT: {
		name: 'Savingsaccount',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: [
					'UPDATESAVINGSOFFICER',
					'UPDATEWITHHOLDTAX',
					'UPDATEWITHHOLDTAX_CHECKER',
					'UPDATE',
					'UPDATE_CHECKER',
				],
			},
			{
				name: 'Approve',
				values: ['APPROVE', 'APPROVE_CHECKER'],
			},
			{
				name: 'Reverse',
				values: ['REVERSETRANSACTION', 'REVERSETRANSACTION_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Withdraw Checker',
				value: 'WITHDRAW_CHECKER',
			},
			{
				name: 'Updatesavingsofficer',
				value: 'UPDATESAVINGSOFFICER',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Applyannualfee',
				value: 'APPLYANNUALFEE',
			},
			{
				name: 'Blockcredit Checker',
				value: 'BLOCKCREDIT_CHECKER',
			},
			{
				name: 'Withdraw',
				value: 'WITHDRAW',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Approvalundo',
				value: 'APPROVALUNDO',
			},
			{
				name: 'Blockcredit',
				value: 'BLOCKCREDIT',
			},
			{
				name: 'Close Checker',
				value: 'CLOSE_CHECKER',
			},
			{
				name: 'Holdamount Checker',
				value: 'HOLDAMOUNT_CHECKER',
			},
			{
				name: 'Unblockdebit Checker',
				value: 'UNBLOCKDEBIT_CHECKER',
			},
			{
				name: 'Unblock Checker',
				value: 'UNBLOCK_CHECKER',
			},
			{
				name: 'Withdrawal',
				value: 'WITHDRAWAL',
			},
			{
				name: 'Activate Checker',
				value: 'ACTIVATE_CHECKER',
			},
			{
				name: 'Approvalundo Checker',
				value: 'APPROVALUNDO_CHECKER',
			},
			{
				name: 'Blockdebit Checker',
				value: 'BLOCKDEBIT_CHECKER',
			},
			{
				name: 'Block',
				value: 'BLOCK',
			},
			{
				name: 'Deposit Checker',
				value: 'DEPOSIT_CHECKER',
			},
			{
				name: 'Postinterest',
				value: 'POSTINTEREST',
			},
			{
				name: 'Adjusttransaction',
				value: 'ADJUSTTRANSACTION',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
			{
				name: 'Blockdebit',
				value: 'BLOCKDEBIT',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Deposit',
				value: 'DEPOSIT',
			},
			{
				name: 'Releaseamount',
				value: 'RELEASEAMOUNT',
			},
			{
				name: 'Reversetransaction',
				value: 'REVERSETRANSACTION',
			},
			{
				name: 'Unblockcredit Checker',
				value: 'UNBLOCKCREDIT_CHECKER',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Releaseamount Checker',
				value: 'RELEASEAMOUNT_CHECKER',
			},
			{
				name: 'Unblockdebit',
				value: 'UNBLOCKDEBIT',
			},
			{
				name: 'Unblock',
				value: 'UNBLOCK',
			},
			{
				name: 'Undotransaction',
				value: 'UNDOTRANSACTION',
			},
			{
				name: 'Withdrawal Checker',
				value: 'WITHDRAWAL_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Updatewithholdtax',
				value: 'UPDATEWITHHOLDTAX',
			},
			{
				name: 'Holdamount',
				value: 'HOLDAMOUNT',
			},
			{
				name: 'Unblockcredit',
				value: 'UNBLOCKCREDIT',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Removesavingsofficer',
				value: 'REMOVESAVINGSOFFICER',
			},
			{
				name: 'Updatewithholdtax Checker',
				value: 'UPDATEWITHHOLDTAX_CHECKER',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Applyannualfee Checker',
				value: 'APPLYANNUALFEE_CHECKER',
			},
			{
				name: 'Approve Checker',
				value: 'APPROVE_CHECKER',
			},
			{
				name: 'Block Checker',
				value: 'BLOCK_CHECKER',
			},
			{
				name: 'Calculateinterest',
				value: 'CALCULATEINTEREST',
			},
			{
				name: 'Calculateinterest Checker',
				value: 'CALCULATEINTEREST_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Postinterest Checker',
				value: 'POSTINTEREST_CHECKER',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Reject Checker',
				value: 'REJECT_CHECKER',
			},
			{
				name: 'Reversetransaction Checker',
				value: 'REVERSETRANSACTION_CHECKER',
			},
			{
				name: 'Undotransaction Checker',
				value: 'UNDOTRANSACTION_CHECKER',
			},
		],
	},
	SAVINGSACCOUNTCHARGE: {
		name: 'Savingsaccountcharge',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Waive Checker',
				value: 'WAIVE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Inactivate Checker',
				value: 'INACTIVATE_CHECKER',
			},
			{
				name: 'Pay',
				value: 'PAY',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Waive',
				value: 'WAIVE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Inactivate',
				value: 'INACTIVATE',
			},
			{
				name: 'Pay Checker',
				value: 'PAY_CHECKER',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	SAVINGSPRODUCT: {
		name: 'Savingsproduct',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	SCHEDULER: {
		name: 'Scheduler',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Executejob',
				value: 'EXECUTEJOB',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	SHAREACCOUNT: {
		name: 'Shareaccount',
		filters: [
			{
				name: 'Approve',
				values: ['APPROVEADDITIONALSHARES', 'APPROVE'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Rejectadditionalshares',
				value: 'REJECTADDITIONALSHARES',
			},
			{
				name: 'Reject',
				value: 'REJECT',
			},
			{
				name: 'Undoapproval',
				value: 'UNDOAPPROVAL',
			},
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Redeemshares',
				value: 'REDEEMSHARES',
			},
			{
				name: 'Applyadditionalshares',
				value: 'APPLYADDITIONALSHARES',
			},
			{
				name: 'Approveadditionalshares',
				value: 'APPROVEADDITIONALSHARES',
			},
			{
				name: 'Approve',
				value: 'APPROVE',
			},
		],
	},
	SHAREPRODUCT: {
		name: 'Shareproduct',
		filters: [
			{
				name: 'Create',
				values: ['CREATE_DIVIDEND', 'CREATE_DIVIDEND_CHECKER', 'CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE_DIVIDEND', 'DELETE_DIVIDEND_CHECKER'],
			},
			{
				name: 'Approve',
				values: ['APPROVE_DIVIDEND', 'APPROVE_DIVIDEND_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Approve Dividend',
				value: 'APPROVE_DIVIDEND',
			},
			{
				name: 'Approve Dividend Checker',
				value: 'APPROVE_DIVIDEND_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete Dividend',
				value: 'DELETE_DIVIDEND',
			},
			{
				name: 'Read Dividend',
				value: 'READ_DIVIDEND',
			},
			{
				name: 'Create Dividend',
				value: 'CREATE_DIVIDEND',
			},
			{
				name: 'Create Dividend Checker',
				value: 'CREATE_DIVIDEND_CHECKER',
			},
			{
				name: 'Delete Dividend Checker',
				value: 'DELETE_DIVIDEND_CHECKER',
			},
		],
	},
	SMS: {
		name: 'Sms',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	SMSCAMPAIGN: {
		name: 'Smscampaign',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Activate',
				value: 'ACTIVATE',
			},
			{
				name: 'Close',
				value: 'CLOSE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Reactivate',
				value: 'REACTIVATE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	SSBENEFICIARYTPT: {
		name: 'Ssbeneficiarytpt',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	STAFF: {
		name: 'Staff',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	STAFFIMAGE: {
		name: 'Staffimage',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'STANDINGINSTRUCTION ': {
		name: 'Standinginstruction ',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	Saving_Account_Transaction: {
		name: 'Saving Account Transaction',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Savings Transactions': {
		name: 'Savings Transactions',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Staff Assignment History(Pentaho)': {
		name: 'Staff Assignment History(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	TAXCOMPONENT: {
		name: 'Taxcomponent',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	TAXGROUP: {
		name: 'Taxgroup',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	TELLER: {
		name: 'Teller',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETECASHIERALLOCATION', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATECASHIERALLOCATION', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Allocate',
				value: 'ALLOCATE',
			},
			{
				name: 'Allocatecashtocashier',
				value: 'ALLOCATECASHTOCASHIER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Deletecashierallocation',
				value: 'DELETECASHIERALLOCATION',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Settlecashfromcashier',
				value: 'SETTLECASHFROMCASHIER',
			},
			{
				name: 'Updatecashierallocation',
				value: 'UPDATECASHIERALLOCATION',
			},
		],
	},
	TEMPLATE: {
		name: 'Template',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
	TWOFACTOR_ACCESSTOKEN: {
		name: 'Twofactor Accesstoken',
		actionNames: [
			{
				name: 'Invalidate',
				value: 'INVALIDATE',
			},
		],
	},
	TWOFACTOR_CONFIGURATION: {
		name: 'Twofactor Configuration',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	'Trial Balance': {
		name: 'Trial Balance',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	TxnRunningBalances: {
		name: 'Txnrunningbalances',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'TxnRunningBalances(Pentaho)': {
		name: 'Txnrunningbalances(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	USER: {
		name: 'User',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE_CHECKER'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE_CHECKER'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Create Checker',
				value: 'CREATE_CHECKER',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Delete Checker',
				value: 'DELETE_CHECKER',
			},
		],
	},
	WAIVECHARGE: {
		name: 'Waivecharge',
		actionNames: [
			{
				name: 'Undo',
				value: 'UNDO',
			},
		],
	},
	WORKINGDAYS: {
		name: 'Workingdays',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE_CHECKER'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Update Checker',
				value: 'UPDATE_CHECKER',
			},
		],
	},
	'Written-Off Loans': {
		name: 'Written-Off Loans',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	'Written-Off Loans(Pentaho)': {
		name: 'Written-Off Loans(Pentaho)',
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	XBRLMAPPING: {
		name: 'Xbrlmapping',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	account_opening_checklist: {
		name: 'Account Opening Checklist',
		filters: [
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	client_iprs: {
		name: 'Client Iprs',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	client_transunion: {
		name: 'Client Transunion',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	credit_info: {
		name: 'Credit Info',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	extra_client_details: {
		name: 'Extra Client Details',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
		],
	},
	extra_loan_details: {
		name: 'Extra Loan Details',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	integration_steps: {
		name: 'Integration Steps',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	likelihood: {
		name: 'Likelihood',
		filters: [
			{
				name: 'Update',
				values: ['UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	loan_appraisal: {
		name: 'Loan Appraisal',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Update',
				value: 'UPDATE',
			},
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
		],
	},
	loan_referees: {
		name: 'Loan Referees',
		filters: [
			{
				name: 'Create',
				values: ['CREATE', 'CREATE'],
			},
			{
				name: 'Delete',
				values: ['DELETE', 'DELETE'],
			},
			{
				name: 'Update',
				values: ['UPDATE', 'UPDATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
			{
				name: 'Delete',
				value: 'DELETE',
			},
			{
				name: 'Read',
				value: 'READ',
			},
			{
				name: 'Update',
				value: 'UPDATE',
			},
		],
	},
	survey: {
		name: 'Survey',
		filters: [
			{
				name: 'Create',
				values: ['CREATE'],
			},
		],
		actionNames: [
			{
				name: 'Create',
				value: 'CREATE',
			},
		],
	},
};
